export default __webpack_public_path__ + "static/media/AboutMission.ae8a219a.png";